import { gql } from "@apollo/client";

export const FETCH_USER_DETAILS = gql`
  query getUserDetails {
    myUser {
      clinic
    }
  }
`;

export const CLINICAL_PRODUCT_SEARCH_QUERY = gql`
  query productSearch(
    $searchTerm: String!
    $productTypes: [SearchProductType!]!
  ) {
    productSearch(input: { searchTerm: $searchTerm, productTypes: $productTypes }) {
      id
      title
      productType
      parentId
    }
  }
`;

export const GET_SKU_BY_CLINICAL_PRODUCT_ID_QUERY = gql`
  query inventorySearch(
    $name: String
    $facilityId: String!
    $externalReferences: [InventorySearchExternalReferenceInput!]
  ) {
    inventorySearchTmp(
      input: { name: $name, facilityId: $facilityId, externalReferences: $externalReferences }
      options: { pageSize: 100 }
    ) {
      edges {
        node {
          id
          name
          measurementUnit
          measurementQuantity
          active
        }
      }
    }
  }
`;

export const GET_VMP_BY_ID_QUERY = gql`
  query getVmpById($id: String!) {
    getVmpById(input: { id: $id }) {
      title
      id
      productType
      vtmId
      legacyMedicationId
    }
  }
`;

export const GET_AMP_BY_ID_QUERY = gql`
  query getAmpById($id: String!) {
    getAmpById(input: { id: $id }) {
      title
      id
      productType
      vmpId
    }
  }
`;

export const CREATE_SKU = gql`
  mutation createSku($input: CreateSkuInput!) {
    createSku(input: $input) {
      id
    }
  }
`;

export const GET_NON_PHARMA_ITEM_BY_ID_QUERY = gql`
  query getNonPharmaItemById($id: String!) {
    getNonPharmaItemById(input: { id: $id }) {
      id
      title
      productType
    }
  }
`;
